// loader-interceptor.service.ts
import {Injectable, Injector} from '@angular/core';
import {
    HttpResponse,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoadingService, SKIP_LOADING} from "./loading.service";
import {Router} from "@angular/router";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from "@jsverse/transloco";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    private requests: HttpRequest<any>[] = [];

    // TranslocoService は HttpClient (辞書ローダ) に依存するため、interceptor に直接注入すると
    // 循環依存になる。表示時点で Injector から取り出す。
    constructor(public router: Router, public loadingService: LoadingService, public toasterService: ToasterService, private injector: Injector) {
    }

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);
        }
        this.loadingService.isLoading.next(this.requests.length > 0);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.context.get(SKIP_LOADING)) {
            return next.handle(req);
        }
        this.requests.push(req);
        this.loadingService.isLoading.next(true);
        return Observable.create(observer => {
            const subscription = next.handle(req)
                .subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            this.removeRequest(req);
                            observer.next(event);
                        }
                    },
                    err => {
                        if (err instanceof HttpErrorResponse && err.statusText == "Unauthorized") {
                            const transloco = this.injector.get(TranslocoService);
                            this.toasterService.pop('info', transloco.translate('shell.logout'), transloco.translate('shell.session_ended'));
                            this.router.navigateByUrl('login');
                        }
                        this.removeRequest(req);
                        observer.error(err);
                    },
                    () => {
                        this.removeRequest(req);
                        observer.complete();
                    });
            return () => {
                this.removeRequest(req);
                subscription.unsubscribe();
            };
        });
    }
}
